import React from 'react';
import classNames from 'classnames';

import { Content } from '../Typography';

import './style.scss';

export default ({ isFixedHeight = true, children }) => (
  <Content
    className={classNames({
      messages: true,
      'messages--is-fixed-height': isFixedHeight,
    })}
    id="messages"
  >
    {children}
  </Content>
);

export const Message = ({ className, header, body, isReply }) => (
  <div
    className={classNames(className, {
      message: true,
      'message--is-reply': isReply,
    })}
  >
    <div className="message__body">
      <div className="message__sender">{header}</div>
      {body}
    </div>
  </div>
);
